import { staticUrl, getAppDownloadUrl, iosDeeplink } from '@/config';
import { Dialog } from '@zyf2e/capui-mobile';
import { env, getAdapter } from '@zyf2e/adapt';
import { parse } from 'qs';

export function downloadApp(url) {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua)) {
    location.href = iosDeeplink;
  } else {
    if (/MicroMessenger/gi.test(ua)) {
      location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zyhealth.patient';
    } else {
      location.href = 'http://dl.91jkys.com/files/apps/apk/zyhealth.apk';
    }
  }
  // todo  deeplink 跳转
  // const deeplinkUrl = getAppDownloadUrl(url);
  // const ua = navigator.userAgent;
  // if (/iPhone|iPad|iPod/.test(ua)) {
  //   window.openCheckTimer = null;
  //   location.href = deeplinkUrl;
  //   let num = 0;
  //   const [maxNum, time] = [10, 300];
  //   window.openCheckTimer = setInterval(() => {
  //     console.log(document.visibilityState);
  //     num += 1;
  //     if (document.visibilityState === 'hidden') {
  //       clearInterval(window.openCheckTimer);
  //       window.openCheckTimer = null;
  //       console.log('已安装app');
  //     } else if (num > maxNum) {
  //       clearInterval(window.openCheckTimer);
  //       window.openCheckTimer = null;
  //       console.log('未安装app');
  //     }
  //   }, time);
  // } else {
  //   if (/MicroMessenger/gi.test(ua)) {
  //     // todo 引导浏览器打开
  //     // url = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.zyhealth.patient';
  //   } else {
  //     location.href = deeplinkUrl;
  //     // deeplinkUrl
  //     // url = 'http://dl.91jkys.com/files/apps/apk/zyhealth.apk';
  //   }
  // }
}


export async function openUrl(url, type) {
  if (!env.inAPP && /^native:\/\//.test(url)) {
    try {
      await Dialog.confirm({ message: '请下载智云健康APP' });
      downloadApp(url);
    } catch (error) {
      // do nothing
    }
    return;
  }
  const adapt = getAdapter();

  if (!/^native:\/\//.test(url)) {
    if (type === 'replace') {
      // 小程序内
      if (env.inWechatMiniProgram) {
        wx.miniProgram.redirectTo({
          url: `/pages/common/webview?url=${encodeURIComponent(url)}`
        });
      } else adapt.replace(url);
    } else {
      // 小程序内
      if (env.inWechatMiniProgram) {
        wx.miniProgram.navigateTo({
          url: `/pages/common/webview?url=${encodeURIComponent(url)}`
        });
      } else adapt.open(url);
    }
  } else {
    if (type === 'replace') adapt.replace(url);
    else adapt.open(url);
  }
}


// 单位转换
const preRem = 37.5
export function px2rem(px, deafultVal) {
  return px ? `${px/preRem}rem` : deafultVal
}

/**
 * 获取路由参数
 * @param {*} includeMiniProgramExtraQuery  是否删除小程序链接添加的参数  默认删除
 * @returns
 */
 export function getRouteQuery(includeMiniProgramExtraQuery = false) {
  const query = parse(location.href.replace(/[&|?]from=singlemessage/, '').split('?')[1]);
  if (!includeMiniProgramExtraQuery) {
    // 删除user_token telescope-info  小程序链接默认携带
    delete query.user_token;
    delete query['telescope-info'];
  }

  return query;
}

export const getUrlParam = name => {
  const search = window.location.hash.split('?');
  if (!search[1]) {
    return null;
  }
  const params = search[1].split('&');
  let result = null;
  try {
    params.forEach(val => {
      const arr = val.split('=');
      if (name === arr[0]) {
        result = unescape(arr[1]);
        throw new Error('exist');
      }
    });
  } catch (error) {
    // do nothing
  }
  return result;
};
